import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { useToggle } from '@infl-ts/util-hooks';
import { constVoid } from 'fp-ts/function';
import { createContext, useCallback, useEffect, useRef, useState } from 'react';
import NavigationPrompt from 'react-router-navigation-prompt';
import { UnsavedChangesModal, unsavedMessage } from './unsaved-changes-modal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var UnsavedChangesContext = /*#__PURE__*/createContext({
  isDirty: false,
  setDirtyState: constVoid,
  showUnsavedModal: constVoid
});
export var UnsavedChanges = function UnsavedChanges(_ref) {
  var children = _ref.children;

  var _useState = useState(false),
      isDirty = _useState[0],
      setDirty = _useState[1];

  var dirtyRef = useRef(isDirty);
  var setDirtyState = useCallback(function (isDirty) {
    dirtyRef.current = isDirty;
    setDirty(isDirty);
  }, [setDirty]);

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      modalVisible = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      openModal = _useToggle2$.on,
      closeModal = _useToggle2$.off;

  var _useState2 = useState(function () {
    return function () {
      return setDirtyState(false);
    };
  }),
      forgetChanges = _useState2[0],
      setForgetChanges = _useState2[1];

  useEffect(function () {
    var showUnsavedMessage = function showUnsavedMessage(e) {
      if (!dirtyRef.current) return false;

      if (dirtyRef.current) {
        e.returnValue = unsavedMessage;
        return unsavedMessage;
      }
    };

    window.addEventListener('beforeunload', showUnsavedMessage);
    return function () {
      return window.removeEventListener('beforeunload', showUnsavedMessage);
    };
  }, []);
  var handleOpenModal = useCallback(function (onDiscardChanges) {
    setForgetChanges(function () {
      return function () {
        setDirtyState(false);
        closeModal();
        onDiscardChanges && onDiscardChanges();
      };
    });
    openModal();
  }, [setForgetChanges, setDirtyState, closeModal, openModal]);
  return /*#__PURE__*/_jsxs(UnsavedChangesContext.Provider, {
    value: {
      isDirty: isDirty,
      setDirtyState: setDirtyState,
      showUnsavedModal: handleOpenModal
    },
    "data-element": "unknown",
    "data-component": "UnsavedChanges",
    "data-source-file": "use-unsaved-changes.tsx",
    children: [/*#__PURE__*/_jsx(NavigationPrompt, {
      when: isDirty,
      "data-element": "NavigationPrompt",
      "data-component": "UnsavedChanges",
      "data-source-file": "use-unsaved-changes.tsx",
      children: function children(_ref2) {
        var onConfirm = _ref2.onConfirm,
            _onCancel = _ref2.onCancel;
        return /*#__PURE__*/_jsx(UnsavedChangesModal, {
          open: true,
          onCancel: function onCancel() {
            closeModal();

            _onCancel();
          },
          onContinue: function onContinue() {
            forgetChanges();
            onConfirm();
          }
        });
      }
    }), /*#__PURE__*/_jsx(UnsavedChangesModal, {
      open: modalVisible,
      onCancel: closeModal,
      onContinue: forgetChanges,
      "data-element": "UnsavedChangesModal",
      "data-source-file": "use-unsaved-changes.tsx"
    }), children]
  });
};